/* ==========================================================================
   WOHLGANG — Upsell (cart drawer + cart page + popup)

   One product, three bundle tiers. This nudges a shopper who already has
   1–2 pairs in the cart toward tier 2 (3 pairs) or tier 3 (5 pairs). It
   adds NO discount of its own: Shopify's automatic quantity discounts
   (min qty 3 / min qty 5 — the very same ones the PDP bundle selector in
   wg-pdp.js relies on) apply the moment the cart hits the threshold, so
   the promised saving is real and always matches wg-hero.

   Fed by #wg-upsell-config (snippets/wg-upsell-config.liquid). Surfaces:
     - inline block  snippets/wg-upsell-cart.liquid  — server-rendered inside
                     the cart drawer and, as a section, on the cart page
     - popup         snippets/wg-upsell-popup.liquid — <dialog>, once/session

   The inline block is fully rendered by Liquid. This script only:
     1. intercepts its "+N Paar" button  -> POST /cart/change
     2. lets the theme's own cart components self-refresh from the
        cart:update event (same handshake product-form.js uses)
     3. re-fetches the standalone cart-page section after cart:update
        (the drawer copy refreshes for free with the header section)
     4. drives the popup: exit-intent / delay, gated on cart state + session
   ========================================================================== */
(function () {
  'use strict';

  var configEl = document.getElementById('wg-upsell-config');
  if (!configEl) return;

  var CONFIG;
  try {
    CONFIG = JSON.parse(configEl.textContent);
  } catch (e) {
    return;
  }
  if (!CONFIG || !CONFIG.enabled) return;

  var SESSION_KEY = 'wg-upsell-popup-seen';
  var routes = (typeof Theme !== 'undefined' && Theme.routes) || {};
  var CHANGE_URL = routes.cart_change_url || '/cart/change';
  var CART_JS = (routes.cart_url || '/cart') + '.js';

  /* ---------- helpers ---------------------------------------------------- */

  function euro(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && CONFIG.moneyFormat) {
      return window.Shopify.formatMoney(cents, CONFIG.moneyFormat);
    }
    return (cents / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
  }

  function getCart() {
    return fetch(CART_JS, { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  /* Which tier to aim at for a given pair count, or null when maxed out. */
  function targetTier(pairs) {
    var tiers = CONFIG.tiers || [];
    for (var i = 0; i < tiers.length; i++) {
      if (pairs < tiers[i].qty) return tiers[i];
    }
    return null;
  }

  function wgPairsInCart(cart) {
    return (cart.items || []).reduce(function (sum, item) {
      return item.product_id === CONFIG.productId ? sum + item.quantity : sum;
    }, 0);
  }

  /* The WG line we grow to hit the threshold: the one with the most pairs. */
  function leadLine(cart) {
    var lead = null;
    (cart.items || []).forEach(function (item, index) {
      if (item.product_id !== CONFIG.productId) return;
      if (!lead || item.quantity > lead.quantity) {
        lead = { line: index + 1, key: item.key, quantity: item.quantity };
      }
    });
    return lead;
  }

  /* Section ids the theme needs re-rendered on a cart mutation. */
  function cartSectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component').forEach(function (el) {
      var id = el.dataset.sectionId;
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    return ids;
  }

  /* Grow `line` to `quantity`, then let the theme refresh itself. */
  function bumpLine(line, quantity) {
    var body = JSON.stringify({
      line: line,
      quantity: quantity,
      sections: cartSectionIds().join(','),
      sections_url: window.location.pathname
    });

    return fetch(CHANGE_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        if (!cart || cart.errors) throw new Error('cart change failed');
        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cart,
              sourceId: 'wg-upsell',
              data: {
                source: 'wg-upsell',
                itemCount: cart.item_count,
                sections: cart.sections
              }
            }
          })
        );
        return cart;
      });
  }

  /* ---------- inline block: one-click "+N Paar" ------------------------- */

  function bindInline(scope) {
    (scope || document).querySelectorAll('[data-wg-upsell-add]').forEach(function (btn) {
      if (btn.dataset.wgBound) return;
      btn.dataset.wgBound = '1';

      btn.addEventListener('click', function (event) {
        event.preventDefault();
        if (btn.disabled) return;

        var line = parseInt(btn.getAttribute('data-line'), 10);
        var toQty = parseInt(btn.getAttribute('data-to-qty'), 10);
        if (!line || !toQty) return;

        btn.disabled = true;
        btn.classList.add('is-loading');

        bumpLine(line, toQty).catch(function () {
          btn.disabled = false;
          btn.classList.remove('is-loading');
        });
      });
    });
  }

  /* Re-fetch the standalone cart-page section (the drawer copy comes back
     for free with the header section). */
  function refreshStandalone() {
    var host = document.querySelector('[data-wg-upsell-section]');
    if (!host) return;
    var id = host.getAttribute('data-wg-upsell-section');

    fetch(window.location.pathname + '?section_id=' + encodeURIComponent(id), {
      headers: { Accept: 'text/html' }
    })
      .then(function (r) {
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var next = doc.querySelector('[data-wg-upsell-cart]');
        var current = host.querySelector('[data-wg-upsell-cart]');
        if (next && current) {
          current.replaceWith(next);
          bindInline(host);
        } else if (!next && current) {
          current.remove();
        }
      })
      .catch(function () {});
  }

  /* ---------- popup ---------------------------------------------------- */

  var popup = document.getElementById('wg-upsell-popup');

  function popupEligible(cart) {
    if (!popup || !CONFIG.popup || !CONFIG.popup.enabled) return false;
    if (sessionStorage.getItem(SESSION_KEY)) return false;
    var pairs = wgPairsInCart(cart);
    return pairs > 0 && !!targetTier(pairs);
  }

  function fillPopup(cart) {
    var pairs = wgPairsInCart(cart);
    var tier = targetTier(pairs);
    var lead = leadLine(cart);
    if (!tier || !lead) return false;

    var need = tier.qty - pairs;
    var setEl = function (sel, text) {
      var el = popup.querySelector(sel);
      if (el) el.textContent = text;
    };

    setEl('[data-wg-up-need]', need === 1 ? '1 Paar' : need + ' Paar');
    setEl('[data-wg-up-label]', tier.label);
    setEl('[data-wg-up-saving]', tier.savingText || euro(tier.saving));

    var cta = popup.querySelector('[data-wg-up-confirm]');
    if (cta) {
      cta.setAttribute('data-line', String(lead.line));
      cta.setAttribute('data-to-qty', String(lead.quantity + need));
    }
    return true;
  }

  function openPopup() {
    if (!popup || popup.open) return;
    getCart().then(function (cart) {
      if (!popupEligible(cart)) return;
      if (!fillPopup(cart)) return;
      sessionStorage.setItem(SESSION_KEY, '1');
      if (typeof popup.showModal === 'function') popup.showModal();
      else popup.setAttribute('open', '');
    });
  }

  function bindPopup() {
    if (!popup) return;

    var trigger = (CONFIG.popup && CONFIG.popup.trigger) || 'both';
    var armed = true;

    if (trigger === 'delay' || trigger === 'both') {
      var delay = Math.max(3, (CONFIG.popup && CONFIG.popup.delay) || 15) * 1000;
      setTimeout(function () {
        if (armed) openPopup();
      }, delay);
    }

    if (trigger === 'exit' || trigger === 'both') {
      document.addEventListener('mouseout', function (e) {
        if (!armed) return;
        if (e.clientY <= 0 && !e.relatedTarget) openPopup();
      });
    }

    popup.querySelectorAll('[data-wg-up-close]').forEach(function (el) {
      el.addEventListener('click', function () {
        armed = false;
        popup.close ? popup.close() : popup.removeAttribute('open');
      });
    });

    popup.addEventListener('click', function (e) {
      if (e.target === popup) {
        armed = false;
        popup.close ? popup.close() : popup.removeAttribute('open');
      }
    });

    var confirm = popup.querySelector('[data-wg-up-confirm]');
    if (confirm) {
      confirm.addEventListener('click', function (event) {
        event.preventDefault();
        var line = parseInt(confirm.getAttribute('data-line'), 10);
        var toQty = parseInt(confirm.getAttribute('data-to-qty'), 10);
        if (!line || !toQty) return;

        confirm.disabled = true;
        confirm.classList.add('is-loading');
        armed = false;

        bumpLine(line, toQty)
          .then(function () {
            popup.close ? popup.close() : popup.removeAttribute('open');
          })
          .catch(function () {
            confirm.disabled = false;
            confirm.classList.remove('is-loading');
          });
      });
    }
  }

  /* ---------- wire up ------------------------------------------------- */

  function init() {
    bindInline(document);
    bindPopup();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // After any cart change (ours or the theme's), re-bind the drawer button —
  // the header section is morphed in place — and refresh the standalone
  // cart-page section, which the theme does not know about.
  document.addEventListener('cart:update', function () {
    setTimeout(function () {
      bindInline(document);
      refreshStandalone();
    }, 60);
  });
})();
